import { getVendorTaxonomySwitchFunc } from '@zola-helpers/client/dist/es/marketplace/vendorUtils';
import {
  ACCESSORIES_TAXONOMY_KEY,
  ACCOMMODATIONS_TAXONOMY_KEY,
  ALTERATIONS_PRESERVATION_TAXONOMY_KEY,
  BANDS_DJS_TAXONOMY_KEY,
  BAR_SERVICES_TAXONOMY_KEY,
  BRIDAL_SHOPS_TAXONOMY_KEY,
  CAKES_DESSERTS_TAXONOMY_KEY,
  CATERING_TAXONOMY_KEY,
  CELEBRANTS_OFFICIANTS_TAXONOMY_KEY,
  CHILDCARE_SERVICES_TAXONOMY_KEY,
  CLOTHING_RENTALS_TAXONOMY_KEY,
  FLORISTS_TAXONOMY_KEY,
  GENERAL_SERVICES_TAXONOMY_KEY,
  GIFT_FAVORS_TAXONOMY_KEY,
  HAIR_MAKEUP_TAXONOMY_KEY,
  INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY,
  JEWELERS_TAXONOMY_KEY,
  LIGHTING_AV_TAXONOMY_KEY,
  PHOTOBOOTHS_TAXONOMY_KEY,
  PHOTOGRAPHERS_TAXONOMY_KEY,
  PLANNERS_TAXONOMY_KEY,
  RENTALS_DECOR_TAXONOMY_KEY,
  SERVICE_STAFF_TAXONOMY_KEY,
  TRANSPORTATION_PROVIDERS_TAXONOMY_KEY,
  VARIETY_ACTS_TAXONOMY_KEY,
  VENUES_TAXONOMY_KEY,
  VIDEOGRAPHERS_TAXONOMY_KEY,
  VendorTaxonomyKey,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { BobbypinIcon } from '../components/SvgIconsV3/Bobbypin';
import { BuildingChurch1Icon } from '../components/SvgIconsV3/BuildingChurch1';
import { BusIcon } from '../components/SvgIconsV3/Bus';
import { CakeIcon } from '../components/SvgIconsV3/Cake';
import { CalligrapherIcon } from '../components/SvgIconsV3/Calligrapher';
import { CameraIcon } from '../components/SvgIconsV3/Camera';
import { CocktailIcon } from '../components/SvgIconsV3/Cocktail';
import { EarringsIcon } from '../components/SvgIconsV3/Earrings';
import { FlowerRoseIcon } from '../components/SvgIconsV3/FlowerRose';
import { GiftIcon } from '../components/SvgIconsV3/Gift';
import { HighHeelsIcon } from '../components/SvgIconsV3/HighHeels';
import { ListWeddingIcon } from '../components/SvgIconsV3/ListWedding';
import { LivePhotoIcon } from '../components/SvgIconsV3/LivePhoto';
import { LuggageHotelIcon } from '../components/SvgIconsV3/LuggageHotel';
import { Mirror1Icon } from '../components/SvgIconsV3/Mirror1';
import { MusicIcon } from '../components/SvgIconsV3/Music';
import { Necklace4Icon } from '../components/SvgIconsV3/Necklace4';
import { RingBellIcon } from '../components/SvgIconsV3/RingBell';
import { StrollerIcon } from '../components/SvgIconsV3/Stroller';
import { ToolsKitchenIcon } from '../components/SvgIconsV3/ToolsKitchen';
import { VenueIcon } from '../components/SvgIconsV3/Venue';
import { Video1Icon } from '../components/SvgIconsV3/Video1';
import { WeddingBalloonsIcon } from '../components/SvgIconsV3/WeddingBalloons';
import { WeddingDressIcon } from '../components/SvgIconsV3/WeddingDress';
import { WeddingLightBulbIcon } from '../components/SvgIconsV3/WeddingLightBulb';
import { WeddingRingsIcon } from '../components/SvgIconsV3/WeddingRings';

import { CreateIconComponentProps } from '../components/SvgIcons/CreateIconComponent';

export const getVendorIconV3 = getVendorTaxonomySwitchFunc<
  VendorTaxonomyKey | 'all',
  React.FC<CreateIconComponentProps>
>({
  [ACCESSORIES_TAXONOMY_KEY]: EarringsIcon,
  [ACCOMMODATIONS_TAXONOMY_KEY]: LuggageHotelIcon,
  [ALTERATIONS_PRESERVATION_TAXONOMY_KEY]: BobbypinIcon,
  [BANDS_DJS_TAXONOMY_KEY]: MusicIcon,
  [BAR_SERVICES_TAXONOMY_KEY]: CocktailIcon,
  [BRIDAL_SHOPS_TAXONOMY_KEY]: WeddingDressIcon,
  [CAKES_DESSERTS_TAXONOMY_KEY]: CakeIcon,
  [CATERING_TAXONOMY_KEY]: ToolsKitchenIcon,
  [CELEBRANTS_OFFICIANTS_TAXONOMY_KEY]: BuildingChurch1Icon,
  [CHILDCARE_SERVICES_TAXONOMY_KEY]: StrollerIcon,
  [CLOTHING_RENTALS_TAXONOMY_KEY]: HighHeelsIcon,
  [FLORISTS_TAXONOMY_KEY]: FlowerRoseIcon,
  [GENERAL_SERVICES_TAXONOMY_KEY]: WeddingRingsIcon,
  [GIFT_FAVORS_TAXONOMY_KEY]: GiftIcon,
  [HAIR_MAKEUP_TAXONOMY_KEY]: Mirror1Icon,
  [INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY]: CalligrapherIcon,
  [JEWELERS_TAXONOMY_KEY]: Necklace4Icon,
  [LIGHTING_AV_TAXONOMY_KEY]: WeddingLightBulbIcon,
  [PHOTOBOOTHS_TAXONOMY_KEY]: LivePhotoIcon,
  [PHOTOGRAPHERS_TAXONOMY_KEY]: CameraIcon,
  [PLANNERS_TAXONOMY_KEY]: ListWeddingIcon,
  [RENTALS_DECOR_TAXONOMY_KEY]: WeddingBalloonsIcon,
  [SERVICE_STAFF_TAXONOMY_KEY]: RingBellIcon,
  [TRANSPORTATION_PROVIDERS_TAXONOMY_KEY]: BusIcon,
  [VARIETY_ACTS_TAXONOMY_KEY]: WeddingRingsIcon,
  [VENUES_TAXONOMY_KEY]: VenueIcon,
  [VIDEOGRAPHERS_TAXONOMY_KEY]: Video1Icon,
  all: WeddingRingsIcon,
});

export default getVendorIconV3;
